import { useState, useEffect } from "react";
import axios from "axios";
import "../Login page/LoginRegister.css";
import logo from "../../Assets/EMEI logo.jpeg";
import { useNavigate } from "react-router-dom";

const API_URL = "http://localhost:5000/api/auth";

export default function LoginRegister() {
  const navigate = useNavigate();
// -----------------------------
// Voice Function
// -----------------------------

const speak = (text) => {

  window.speechSynthesis.cancel();

  const speech = new SpeechSynthesisUtterance(text);

  speech.lang = "en-GB";
  speech.rate = 0.9;
  speech.pitch = 1;
  speech.volume = 1;

  const voices = window.speechSynthesis.getVoices();

  const femaleVoice = voices.find(
    voice =>
      voice.lang.startsWith("en") &&
      voice.name.toLowerCase().includes("female")
  );

  if (femaleVoice) {
    speech.voice = femaleVoice;
  }

  window.speechSynthesis.speak(speech);
};
useEffect(() => {
  speak("Welcome to the Student Portal");
}, []);
const changePage = (isRegister) => {

  setMessage("");

  setRegister(isRegister);

  if (isRegister) {
    speak("Registration Page");
  } else {
    speak("Login Page");
  }

};
  // -----------------------------
  // STATES
  // -----------------------------
  

  const [register, setRegister] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

const [loginData, setLoginData] = useState({
  name: "",
  email: "",
  registrationNo: "",
  password: "",
  remember: false,
});

  const [registerData, setRegisterData] = useState({
    fullname: "",
    email: "",
    phone: "",
    registrationNo: "",
    stream: "",
    college: "",
    year: "",
    password: "",
    confirmPassword: "",
  });

  // -----------------------------
  // LEFT PANEL CONTENT
  // -----------------------------

  const leftContent = register
    ? {
        title: "Welcome!",
        subtitle: "Create Your Student Account",
        description:
          "Join our learning community and start your educational journey today.",
        features: [
          "📝 Easy Registration",
          "🎓 Start Learning Today",
          "🚀 Build Your Future",
        ],
      }
    : {
        title: "Welcome Back!",
        subtitle: "Learn. Grow. Connect.",
        description:
          "Secure student portal with modern authentication.",
        features: [
          "📘 Quality Education",
          "👨‍🏫 Expert Teachers",
          "🔒 Secure Login",
        ],
      };

  // -----------------------------
  // LOGIN INPUT
  // -----------------------------

  const handleLoginChange = (e) => {
    const { name, value, type, checked } = e.target;

    setLoginData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  // -----------------------------
  // REGISTER INPUT
  // -----------------------------

  const handleRegisterChange = (e) => {
    const { name, value } = e.target;

    setRegisterData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // -----------------------------
  // LOGIN
  // -----------------------------

  const handleLogin = async (e) => {
    e.preventDefault();

    setLoading(true);
    setMessage("");

    const payload = {
      email: (loginData.email || "").trim().toLowerCase(),
      registrationNo: (loginData.registrationNo || "").trim(),
      password: loginData.password,
    };

    try {
      const res = await axios.post(`${API_URL}/login`, payload);

      localStorage.setItem("token", res.data.token);
      localStorage.setItem("student", JSON.stringify(res.data.student));

      setMessage("Login Successful!");
      speak(`Login successful. Welcome again ${res.data.student?.fullname || "Student"}. `);
      navigate("/student-dashboard");
    } catch (err) {
      const error = err.response?.data?.message || "Login Failed";
      setMessage(error);
      speak(error);
    } finally {
      setLoading(false);
    }
  };

  // -----------------------------
  // REGISTER
  // -----------------------------

  const handleRegister = async (e) => {
    e.preventDefault();

    if (
      registerData.password !==
      registerData.confirmPassword
    ) {
      return setMessage("Passwords do not match");
    }

    setLoading(true);
    setMessage("");

    const payload = {
      fullname: registerData.fullname.trim(),
      email: (registerData.email || "").trim().toLowerCase(),
      phone: registerData.phone.trim(),
      registrationNo: registerData.registrationNo.trim(),
      stream: registerData.stream,
      college: registerData.college.trim(),
      year: registerData.year,
      password: registerData.password,
      confirmPassword: registerData.confirmPassword,
    };

    try {
      const res = await axios.post(`${API_URL}/register`, payload);

      localStorage.setItem("token", res.data.token);
      localStorage.setItem("student", JSON.stringify(res.data.student));

      setMessage("Registration Successful!");

      setLoginData((prev) => ({
        ...prev,
        name: res.data.student.fullname,
        email: res.data.student.email,
        registrationNo: res.data.student.registrationNo,
        password: "",
      }));

      speak(`Congratulations ${res.data.student.fullname}. Welcome to EMEI's FAMILY`);

      setRegisterData({
        fullname: "",
        email: "",
        phone: "",
        registrationNo: "",
        stream: "",
        college: "",
        year: "",
        password: "",
        confirmPassword: "",
      });

      setTimeout(() => {
        navigate("/student-dashboard");
      }, 1200);

    } catch (err) {

const error =
  err.response?.data?.message || "Registration Failed";

setMessage(error);

speak(error);

    } finally {

      setLoading(false);

    }
  };

return (
  <div className="login-page">

    {/* Left Section */}

    <div className="left-section">
 <div className="logo-box">

    <div className="logo-ring">

<img
  src={logo}
  alt="College Logo"
  className="college-logo"
/>

    </div>

  </div>

<div
  key={register ? "register" : "login"}
  className="contentL content-animation"
>

  <h1>{leftContent.title}</h1>

  <h2>{leftContent.subtitle}</h2>

  <p>{leftContent.description}</p>

  {leftContent.features.map((feature, index) => (
    <div className="feature" key={index}>
      {feature}
    </div>
  ))}

</div>

    </div>

    {/* Right Section */}

    <div className="right-section">
      <div className="admin-access">

  <button
    className="admin-btn"
    onClick={() => navigate("/admin-login")}
  >
    👤 Admin
  </button>

</div>

      <div className="card">

        <div className={`flip-card ${register ? "flipped" : ""}`}>

          <div className="flip-card-inner">

            {/* ================= LOGIN SIDE ================= */}

            <div className="flip-card-front">

              <div className="tabs">

 <button
  type="button"
  className={!register ? "active" : ""}
  onClick={() => changePage(false)}
>
  Login
</button>

<button
  type="button"
  className={register ? "active" : ""}
  onClick={() => changePage(true)}
>
  Register
</button>

              </div>

              {message && !register && (
                <div className="message">
                  {message}
                </div>
              )}

              <form onSubmit={handleLogin}>

              <input
  type="text"
  name="name"
  placeholder="Full Name"
  value={loginData.name}
  onChange={handleLoginChange}
  required
/>

<input
  type="email"
  name="email"
  placeholder="Email Address"
  value={loginData.email}
  onChange={handleLoginChange}
  required
/>

<input
  type="text"
  name="registrationNo"
  placeholder="Registration Number"
  value={loginData.registrationNo}
  onChange={handleLoginChange}
  required
/>

<input
  type="password"
  name="password"
  placeholder="Password"
  value={loginData.password}
  onChange={handleLoginChange}
  required
/>

                <div className="row">

                  <label>

                    <input
                      type="checkbox"
                      name="remember"
                      checked={loginData.remember}
                      onChange={handleLoginChange}
                    />

                    Remember Me

                  </label>

                  <a href="/forgot-password">
                    Forgot Password?
                  </a>

                </div>

                <button
                  className="main-btn"
                  disabled={loading}
                >
                  {loading ? "Logging In..." : "Login"}
                </button>

              </form>

            </div>

            {/* ================= REGISTER SIDE ================= */}

            <div className="flip-card-back">

              <div className="tabs">

                <button
                  type="button"
                  onClick={() => setRegister(false)}
                >
                  Login
                </button>

                <button
                  type="button"
                  className="active"
                  onClick={() => setRegister(true)}
                >
                  Register
                </button>

              </div>

              {message && register && (
                <div className="message">
                  {message}
                </div>
              )}

              <form onSubmit={handleRegister}>

                <div className="student-registration-fields">
                <input
                  type="text"
                  name="fullname"
                  placeholder="Full Name"
                  value={registerData.fullname}
                  onChange={handleRegisterChange}
                  required
                />

                <input
                  type="email"
                  name="email"
                  placeholder="Email Address"
                  value={registerData.email}
                  onChange={handleRegisterChange}
                  required
                />

                <input
                  type="tel"
                  name="phone"
                  placeholder="Phone Number"
                  value={registerData.phone}
                  onChange={handleRegisterChange}
                  required
                />

                <input
                  type="text"
                  name="registrationNo"
                  placeholder="Registration Number"
                  value={registerData.registrationNo}
                  onChange={handleRegisterChange}
                  required
                />

                <select name="stream" value={registerData.stream} onChange={handleRegisterChange} required>
                  <option value="">Select Stream</option>
                  <option value="BCA">BCA</option>
                  <option value="BBA">BBA</option>
                  <option value="B.Tech">B.Tech</option>
                  <option value="Other">Other</option>
                </select>

                <input
                  type="text"
                  name="college"
                  placeholder="College Name"
                  value={registerData.college}
                  onChange={handleRegisterChange}
                  required
                />

                <select name="year" value={registerData.year} onChange={handleRegisterChange} required>
                  <option value="">Select Year</option>
                  <option value="1st Year">1st Year</option>
                  <option value="2nd Year">2nd Year</option>
                  <option value="3rd Year">3rd Year</option>
                  <option value="4th Year">4th Year</option>
                </select>

                <input
                  type="password"
                  name="password"
                  placeholder="Password"
                  value={registerData.password}
                  onChange={handleRegisterChange}
                  required
                />

                <input
                  type="password"
                  name="confirmPassword"
                  placeholder="Confirm Password"
                  value={registerData.confirmPassword}
                  onChange={handleRegisterChange}
                  required
                />

                </div>

                <button
                  className="main-btn"
                  disabled={loading}
                >
                  {loading ? "Creating..." : "Register"}
                </button>
                <div><a href="">Any problem? Need any help?</a></div>

              </form>

            </div>

          </div>

        </div>

      </div>

    </div>

  </div>
);
}
